import styled from 'styled-components';
import Split from 'react-split';

// Main Window Components
export const Overlay = styled.div`
  position: fixed;
  z-index: 10;
  background-color: white;
  height: 100%;
  width: 100%;
`;

export const Layout = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 5px);
`;

export const TabBarAndWindowLayout = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100% - 55px);
  width: 100%;
`;

// Main editor Panels
export const SplitPanelWrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  flex-grow: 1;
  flex-shrink: 1;
  overflow: hidden;
`;

export const SplitPanelContainer = styled(Split)`
  display: flex;
  flex-direction: row;
  height: 100%;
  width: calc(100% - 55px);
  .gutter {
    display: flex;
    flex-shrink: 0;
    flex-grow: 0;
    :hover {
      cursor: ew-resize;
    }
  }
`;

export const TooltipWrapper = styled.div`
  text-align: left;
`;

// Side Bar
export const TabsBar = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  flex-grow: 0;
  height: 100%;
  width: 55px;
  padding: 10px 0px 5px 0px;
  border-right: 1px solid ${({ theme }) => theme.vars.newColor.lightGS1};
  .tabButton {
    margin: 5px;
    padding: 5px;
  }
  div {
    display: flex;
    flex-direction: column;
    align-content: center;
    align-self: center;
  }
`;

export const SectionBreak = styled.div`
  height: 2px;
  margin: 5px;
  width: 30px;
  background-color: ${({ theme }) => theme.vars.newColor.lightGS1};
`;
export const PanelIconSection = styled.div``;
export const BottomIconSection = styled.div`
  flex-grow: 1;
  justify-content: flex-end;
`;

// Bottom Bar
export const Circle = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${({ theme }) => theme.vars.newColor.lightGS1};
`;

// Name Bar
export const NameBarElement = styled.div`
  display: flex;
  padding-left: 20px;
  width: 100%;
  height: 40px;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.vars.newColor.lightGS1};
`;

export const NameBarElementItem = styled.div<{ minWidth?: string }>`
  display: flex;
  padding-left: 20px;
  padding-right: 20px;
  gap: 5px;
  ${({ minWidth }) => minWidth && `min-width: ${minWidth};`}
`;

// Windows
// Left Panels
// Editor Window
export const EditorContainer = styled.div`
  flex-grow: 1;
  flex-shrink: 1;
  position: relative;
`;

// Link Config
export const LeftConfigContainer = styled.div`
  flex-grow: 1;
`;

export const LogoBox = styled.div`
  border: 1px solid ${({ theme }) => theme.vars.newColor.lightGS1};
  height: 70px;
  width: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const UrlWrapper = styled.div`
  border-top: ${({ theme }) => `2px solid ${theme.vars.newColor.lightGS1}`};
  padding: 20px 0px 0px 0px;
  &:last-of-type {
    border-bottom: ${({ theme }) => `2px solid ${theme.vars.newColor.lightGS1}`};
  }
  .input-wrapper {
    width: 50%;
  }
`;

export const ImageWrapper = styled.div`
  border: ${({ theme }) => `1px solid ${theme.vars.newColor.lightGS1}`};
  padding: 2px;
  height: 25px;
  width: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

// Right Panels

// Preview Required
export const PreviewRequired = styled.div`
  height: 100%;
  background-color: ${({ theme }) => theme.vars.newColor.white};
  padding: 40px;
  overflow: scroll;
  word-break: break-all;
`;

// Invalid Snapshot
export const SnapshotInvalid = styled.div`
  height: 100%;
  background-color: ${({ theme }) => theme.vars.newColor.white};
  padding: 40px;
  overflow: scroll;
  word-break: break-all;
`;

// Preview
export const PreviewContainer = styled.div`
  height: 100%;
  iframe {
    padding: 0;
    border: none;
    width: 100%;
    height: 100%;
  }
`;

// Output
export const OutputContainer = styled.div`
  height: 100%;
  padding: 10px;
  textarea {
    padding: 0;
    border: none;
    width: 100%;
    height: 100%;
    resize: none;
  }
`;

// Link Output
export const LinksPreviewContainer = styled.div`
  height: 100%;
  background-color: ${({ theme }) => theme.vars.newColor.lightGS1};
  padding: 40px;
  overflow: scroll;
  word-break: break-all;
`;

// Validation
export const ValiationContainer = styled.div`
  height: 100%;
  padding: 20px 40px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const ValidationItemsList = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const ValidationItemContainer = styled.div`
  border: ${({ theme }) => `1px solid ${theme.vars.newColor.lightGS1}`};
  padding: 10px 16px;
  margin-bottom: 6px;
  h3 {
    margin: 0;
  }
`;

export const ValidationItemHeaderRightElement = styled.div`
  display: flex;
  justify-content: flex-end;
  flex: 1;
  align-items: center;
`;

export const ValidationItemHeaderLeftElement = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex: 1;
`;

export const NameBarRightElement = styled.div`
  display: flex;
  justify-content: flex-end;
  flex: 1;
  padding-right: 5px;
`;
